import { Table } from 'antd';
import { decrypt } from 'utils/utils';
import { bankMapping } from 'utils/mappings';

const { Column } = Table;

type Props = {
	paymentInfoData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	isLoading: boolean;
};

const encryptionKey: any = process.env.REACT_APP_ENCRYPTION_KEY;
const PaymentInfoDetails = (props: Props) => {
	const {
		paymentInfoData,
		totalRecords,
		currentPage,
		pageSize,
		isLoading,
		tableChangeHandler,
	} = props;
	return (
		<div>
			<Table
				dataSource={paymentInfoData}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
			
				<Column
					title="Account Holder Name"
					dataIndex="accountHolderName"
					key="accountHolderName"
					className="bg-white"
				/>
				<Column
					title="Bank Type"
					dataIndex="bankType"
					key="bankType"
					className="bg-white"
					render={(value: string) => {
						return bankMapping[value]?.name ?? '';
					}}
				/>
				<Column
					title="Account Number"
					dataIndex="accountNumber"
					key="accountNumber"
					className="bg-white"
					render={(value: string) => {
						return value ? decrypt(value, encryptionKey) : '';
					}}
				/>
				<Column
					title="Sort Code"
					dataIndex="sortCode"
					key="sortCode"
					className="bg-white"
				/>
				<Column
					title="Created By"
					dataIndex="createdBy"
					key="createdBy"
					className="bg-white"
				/>
			</Table>
		</div>
	);
};

export default PaymentInfoDetails;
